import { defineNuxtPlugin } from 'nuxt/app';
import { LazyHydrationWrapper } from 'vue3-lazy-hydration';

export default defineNuxtPlugin(function (nuxtApp) {
  nuxtApp.vueApp.component('LazyHydrate', LazyHydrationWrapper);
});
